import React, { useState, useEffect } from "react"
import Cookies from "universal-cookie"
import { useLocation } from "@reach/router"
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies"
import { Link } from "gatsby"

const cookies = new Cookies()

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const consent = cookies.get("gatsby-gdpr-facebook-pixel")
    if (consent === undefined) {
      setIsVisible(true)
    }
  }, [])

  const handleAccept = () => {
    cookies.set("gatsby-gdpr-facebook-pixel", "true", {
      path: "/",
      maxAge: 31536000,
    })
    setIsVisible(false)

    initializeAndTrack(location)
  }

  const handleReject = () => {
    cookies.set("gatsby-gdpr-facebook-pixel", "false", {
      path: "/",
      maxAge: 31536000,
    })
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-0 left-0 w-full sm:max-w-lg bg-white shadow-lg z-50 p-4 sm:p-6 flex flex-col items-center justify-between gap-4">
      <p className="text-sm text-gray-700 max-w-3xl">
          We use cookies to improve your experience and analyze our site
          traffic. By clicking "Accept All", you consent to our use of cookies.
          You can choose to reject non-essential cookies. Learn more in our{" "}
          <Link to="/privacy-policy" className="underline text-main">
            Privacy Policy
          </Link>.
      </p>
      <div className="flex gap-3 w-full">
        <button
          onClick={handleReject}
          className="ss-btn-base ss-btn-color-border"
        >
          Reject All
        </button>
        <button onClick={handleAccept} className="ss-btn-base">
          Accept All
        </button>
      </div>
    </div>
  )
}

export default CookieBanner
